import {
  CustomProductOptionConfigType,
  ICustomProductOptionConfig,
  ICustomProductOptionConfigWithOverrides,
  ICustomProductOptionConfigWithPrice,
} from "@evennt-tech/api-v2-core";
import { parseCents } from "tools/product/formats/formatCents";

export const parseCustomProductOptionConfig = (
  config: ICustomProductOptionConfig,
  showId: string
): ICustomProductOptionConfigWithOverrides &
  ICustomProductOptionConfigWithPrice => {
  const priceUplift = parseCents(config.prices?.[0]?.price ?? 0);
  // One override row per show — never fall back to another show's row.
  const showConfig = config.cpoConfigOverrides?.find(
    (override) => override?.showId === showId
  );
  const showQuantity = showConfig?.quantity;
  const showPrice = showConfig?.prices?.[0]?.price;
  const purchasedQuantity = showConfig?.purchasedQuantity;

  return {
    ...config,
    priceUplift,
    ...(typeof showQuantity === "number" && { showQuantity }),
    ...(typeof showPrice === "number" && { showPrice: parseCents(showPrice) }),
    ...(typeof purchasedQuantity === "number" && { purchasedQuantity }),
  };
};

export const unpackInlineProductConfigs = (
  configs: ICustomProductOptionConfig[] = [],
  showId: string
): (ICustomProductOptionConfigWithPrice &
  ICustomProductOptionConfigWithOverrides)[] => {
  const defaultConfig = configs.find(
    ({ type }) => type === CustomProductOptionConfigType.DEFAULT
  );

  if (!defaultConfig) {
    return [];
  }

  const customConfigs = defaultConfig.enabled
    ? []
    : configs.filter(
        ({ type, enabled }) =>
          type === CustomProductOptionConfigType.CUSTOM && enabled
      );

  return [defaultConfig, ...customConfigs].map((config) =>
    parseCustomProductOptionConfig(config, showId)
  );
};
